<template>
  <div>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Inter Disc/Comm Rate Information</div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6 v-if="newInterCommDiscRate">
              <v-layout row wrap>
                <v-flex xs7>
                  <cal-picker v-model="effDate" :label="labels.effDate" v-validate="'required'" :data-vv-as="labels.effDate" data-vv-name="effDate" :error-messages="errors.collect('effDate')" @input="doEffDate"></cal-picker>
                </v-flex>
                <v-flex xs5>
                  <time-picker v-model="effTime" :label="labels.effTime" v-validate="'required'" :data-vv-as="labels.effTime" data-vv-name="effTime" :error-messages="errors.collect('effTime')" @input="doEffDate"></time-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{labels.effDateQuery}}</v-subheader>
              <div class="title">{{formatDateTime2(interCommDiscRateForm.effDate)}}</div>
            </v-flex>
            <v-flex xs6>
              <v-layout row wrap>
                <v-flex xs7>
                  <cal-picker v-model="endDate" :label="labels.endDate" v-validate="endDateValidation" :min="this.effDate" :data-vv-as="labels.endDate" data-vv-name="endDate" :error-messages="errors.collect('endDate')" @input="doEndDate"></cal-picker>
                </v-flex>
                <v-flex xs5>
                  <time-picker v-model="endTime" :label="labels.endTime" :data-vv-as="labels.endTime" data-vv-name="endTime" :error-messages="errors.collect('endTime')" @input="doEndDate"></time-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4 v-if="fact1to3Search(interCommDiscFactors.fact1) !== null && !newInterCommDiscRate">
                  <v-subheader class="queryLabel">{{fact1to3Search(interCommDiscFactors.fact1)}}</v-subheader>
                  <div class="title">{{interCommDiscRateForm.fact1}}</div>
                </v-flex>
                <v-flex xs4 v-if="interCommDiscFactors.fact1 !== null && newInterCommDiscRate">
                  <v-autocomplete :items="factor1to3ValueListSearch(interCommDiscFactors.fact1)" v-model="interCommDiscRateForm.fact1" :label="fact1to3Search(interCommDiscFactors.fact1)" item-text="label" item-value="value" data-vv-name="fact1" :data-vv-as="labels.fact1" :error-messages="errors.collect('fact1')" v-validate="'required'" :loading="factValueLoading"></v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="fact1to3Search(interCommDiscFactors.fact2) !== null && !newInterCommDiscRate">
                  <v-subheader class="queryLabel">{{fact1to3Search(interCommDiscFactors.fact2)}}</v-subheader>
                  <div class="title">{{interCommDiscRateForm.fact2}}</div>
                </v-flex>
                <v-flex xs4 v-if="interCommDiscFactors.fact2 !== null && newInterCommDiscRate">
                  <v-autocomplete :items="factor1to3ValueListSearch(interCommDiscFactors.fact2)" v-model="interCommDiscRateForm.fact2" :label="fact1to3Search(interCommDiscFactors.fact2)" item-text="label" item-value="value" data-vv-name="fact2" :data-vv-as="labels.fact2" :error-messages="errors.collect('fact2')" v-validate="'required'" :loading="factValueLoading"></v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="fact1to3Search(interCommDiscFactors.fact3) !== null && !newInterCommDiscRate">
                  <v-subheader class="queryLabel">{{fact1to3Search(interCommDiscFactors.fact3)}}</v-subheader>
                  <div class="title">{{interCommDiscRateForm.fact3}}</div>
                </v-flex>
                <v-flex xs4 v-if="interCommDiscFactors.fact3 !== null && newInterCommDiscRate">
                  <v-autocomplete :items="factor1to3ValueListSearch(interCommDiscFactors.fact3)" v-model="interCommDiscRateForm.fact3" :label="fact1to3Search(interCommDiscFactors.fact3)" item-text="label" item-value="value" data-vv-name="fact3" :data-vv-as="labels.fact3" :error-messages="errors.collect('fact3')" v-validate="'required'" :loading="factValueLoading"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4 v-if="fact4to6Search(interCommDiscFactors.fact4) !== null && !newInterCommDiscRate">
                  <v-subheader class="queryLabel">{{fact4to6Search(interCommDiscFactors.fact4)}}</v-subheader>
                  <div class="title">{{interCommDiscRateForm.fact4}}</div>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(interCommDiscFactors.fact4) !== null && newInterCommDiscRate">
                  <v-text-field v-num-mask v-model="interCommDiscRateForm.fact4" :label="fact4to6Search(interCommDiscFactors.fact4)" :error-messages="errors.collect('fact4')" data-vv-name="fact4" :data-vv-as="labels.fact4" v-validate="'required'"></v-text-field>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(interCommDiscFactors.fact5) !== null && !newInterCommDiscRate">
                  <v-subheader class="queryLabel">{{fact4to6Search(interCommDiscFactors.fact5)}}</v-subheader>
                  <div class="title">{{interCommDiscRateForm.fact5}}</div>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(interCommDiscFactors.fact5) !== null && newInterCommDiscRate">
                  <v-text-field v-num-mask v-model="interCommDiscRateForm.fact5" :label="fact4to6Search(interCommDiscFactors.fact5)" :error-messages="errors.collect('fact5')" data-vv-name="fact5" :data-vv-as="labels.fact5" v-validate="'required'"></v-text-field>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(interCommDiscFactors.fact6) !== null && !newInterCommDiscRate">
                  <v-subheader class="queryLabel">{{fact4to6Search(interCommDiscFactors.fact6)}}</v-subheader>
                  <div class="title">{{interCommDiscRateForm.fact6}}</div>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(interCommDiscFactors.fact6) !== null && newInterCommDiscRate">
                  <v-text-field v-num-mask v-model="interCommDiscRateForm.fact6" :label="fact4to6Search(interCommDiscFactors.fact6)" :error-messages="errors.collect('fact6')" data-vv-name="fact6" :data-vv-as="labels.fact6" v-validate="'required'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs6>
                  <v-autocomplete :items="gnList" v-model="interCommDiscRateForm.commGN" :label="labels.commGN" item-text="label" item-value="value" data-vv-name="commGN" :data-vv-as="labels.commGN" :error-messages="errors.collect('commGN')" v-validate="'required'"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs6>
                  <v-text-field v-num-mask v-model="interCommDiscRateForm.commPct" :label="labels.commPct" :error-messages="errors.collect('commPct')" data-vv-name="commPct" :data-vv-as="labels.commPct" v-validate="'required|mask_decimal:2|mask_min_value:0|mask_max_value:100.00'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox :label="labels.protComm" v-model="interCommDiscRateForm.protComm" data-vv-name="protComm" :data-vv-as="labels.protComm"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs6>
                  <v-text-field v-num-mask v-model="interCommDiscRateForm.discPct" :label="labels.discPct" :error-messages="errors.collect('discPct')" data-vv-name="discPct" :data-vv-as="labels.discPct" v-validate="'required|mask_decimal:2|mask_min_value:0|mask_max_value:100.00'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox :label="labels.protDisc" v-model="interCommDiscRateForm.protDisc" data-vv-name="protDisc" :data-vv-as="labels.protDisc"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
                {{newInterCommDiscRate? 'Add Inter Comm/Disc Rate' : 'Update Inter Comm/Disc Rate'}}
                <v-icon right>{{newInterCommDiscRate? 'mdi-sale' : 'mdi-content-save'}}</v-icon>
                </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU } from '@/store/types'
import { formatDisplayTime, formatDisplayDateTime2 } from '@/utils/date'
import toDate from 'date-fns/toDate'

export default {
  data() {
    return {
      labels: {
        effDate: 'Effective Date*',
        effTime: 'Time*',
        effDateQuery: 'Effective Date',
        endDate: 'End Date',
        endTime: 'Time',
        fact1: 'Factor 1 Value',
        fact2: 'Factor 2 Value',
        fact3: 'Factor 3 Value',
        fact4: 'Factor 4 Value',
        fact5: 'Factor 5 Value',
        fact6: 'Factor 6 Value',
        commGN: 'Commission Gross/Net*',
        commPct: 'Commission %',
        discPct: 'Discount %',
        protComm: 'Protect Commision',
        protDisc: 'Protect Discount'
      },
      interCommDiscRateForm: {
        inter: undefined,
        product: undefined,
        effDate: undefined,
        endDate: undefined,
        fact1: 'NA',
        fact2: 'NA',
        fact3: 'NA',
        fact4: 0.00,
        fact5: 0.00,
        fact6: 0.00,
        commGN: undefined,
        commPct: undefined,
        discPct: undefined,
        protComm: false,
        protDisc: false,
        revision: undefined
      },
      effDate: undefined,
      effTime: undefined,
      endDate: undefined,
      endTime: undefined,
      productLoading: false,
      productList: [],
      menu: [],
      newInterCommDiscRate: false,
      submitting: false,
      gnList: [
        { label: 'Gross', value: 'G' },
        { label: 'Net', value: 'N' }
      ],
      busClsList: [],
      schemeList: [],
      planList: [],
      areaList: [],
      busClsLoading: false,
      schemeLoading: false,
      planLoading: false,
      areaLoading: false
    }
  },
  computed: {
    factor1to3List() {
      return this.$store.state.adminInter.intermediary.factor1to3List
    },
    factor4to6List() {
      return this.$store.state.adminInter.intermediary.factor4to6List
    },
    interCommDiscFactorProduct() {
      return this.$store.state.adminInter.intermediary.interCommDiscFactorProduct
    },
    interCommDiscFactorProductAppId() {
      return this.$store.state.adminInter.intermediary.interCommDiscFactorProductAppId
    },
    interCommDiscFactorEffDate() {
      return this.$store.state.adminInter.intermediary.interCommDiscFactorEffDate
    },
    interCommDiscFactors() {
      return this.$store.state.adminInter.intermediary.interCommDiscFactors
    },
    endDateValidation() {
      return 'start_enddate:' + this.interCommDiscRateForm.effDate
    },
    factValueLoading() {
      if (this.busClsLoading || this.schemeLoading || this.planLoading || this.areaLoading) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    async doInit() {
      if (!this.newInterCommDiscRate) {
        // Review
        await this.reviewInterCommDiscRate()
      } else {
        await Promise.all([this.getProductBusClses(), this.getProductSchemes(), this.getPkgPlans(), this.getTravelAreas()])
      }
    },
    async reviewInterCommDiscRate() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.interCommDiscRateGet
      if (apiURI) {
        try {
          const expand = {
            inter: this.inter,
            product: this.interCommDiscRateForm.product,
            effDate: formatDisplayDateTime2(this.interCommDiscRateForm.effDate),
            fact1: this.interCommDiscRateForm.fact1,
            fact2: this.interCommDiscRateForm.fact2,
            fact3: this.interCommDiscRateForm.fact3,
            fact4: this.interCommDiscRateForm.fact4,
            fact5: this.interCommDiscRateForm.fact5,
            fact6: this.interCommDiscRateForm.fact6
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Inter Comm/Disc Factor init
            this.interCommDiscRateForm.inter = data.interCommDiscRate.inter
            this.interCommDiscRateForm.product = data.interCommDiscRate.product
            this.interCommDiscRateForm.effDate = data.interCommDiscRate.effDate
            this.interCommDiscRateForm.endDate = data.interCommDiscRate.endDate
            this.interCommDiscRateForm.fact1 = data.interCommDiscRate.fact1
            this.interCommDiscRateForm.fact2 = data.interCommDiscRate.fact2
            this.interCommDiscRateForm.fact3 = data.interCommDiscRate.fact3
            this.interCommDiscRateForm.fact4 = data.interCommDiscRate.fact4
            this.interCommDiscRateForm.fact5 = data.interCommDiscRate.fact5
            this.interCommDiscRateForm.fact6 = data.interCommDiscRate.fact6
            this.interCommDiscRateForm.commGN = data.interCommDiscRate.commGN
            this.interCommDiscRateForm.commPct = data.interCommDiscRate.commPct
            this.interCommDiscRateForm.discPct = data.interCommDiscRate.discPct
            this.interCommDiscRateForm.protComm = data.interCommDiscRate.protComm
            this.interCommDiscRateForm.protDisc = data.interCommDiscRate.protDisc
            this.interCommDiscRateForm.revision = data.interCommDiscRate.revision
            if (this.interCommDiscRateForm.effDate) {
              this.effDate = this.interCommDiscRateForm.effDate
              this.effTime = formatDisplayTime(this.interCommDiscRateForm.effDate)
            }
            if (this.interCommDiscRateForm.endDate) {
              this.endDate = this.interCommDiscRateForm.endDate
              this.endTime = formatDisplayTime(this.interCommDiscRateForm.endDate)
            } else {
              this.endTime = '00:00'
            }

            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getProductBusClses() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.productBusClsesGet
      if (apiURI) {
        try {
          this.busClsLoading = true
          const expand = {
            product: this.interCommDiscFactorProduct
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            if (result.data.totalElements > 0) {
              const { data } = result.data
              data.map((productBusCls) => {
                const convertProductBusCls = {
                  value: productBusCls.value,
                  label: productBusCls.label
                }
                this.busClsList.push(convertProductBusCls)
              })
            } else {
              this.busClsList = []
            }
          } else {
            this.busClsList = []
          }
          this.busClsLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.busClsLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getProductSchemes() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.productSchemesGet
      if (apiURI) {
        try {
          this.schemeLoading = true
          const expand = {
            product: this.interCommDiscFactorProduct,
            appId: this.interCommDiscFactorProductAppId
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            if (result.data.totalElements > 0) {
              const { data } = result.data
              data.map((productScheme) => {
                const convertProductScheme = {
                  value: productScheme.value,
                  label: productScheme.label
                }
                this.schemeList.push(convertProductScheme)
              })
            } else {
              this.schemeList = []
            }
          } else {
            this.schemeList = []
          }
          this.schemeLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.schemeLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getPkgPlans() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.pkgPlansGet
      if (apiURI) {
        try {
          this.planLoading = true
          const expand = {
            product: this.interCommDiscFactorProduct,
            appId: this.interCommDiscFactorProductAppId
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            if (result.data.totalElements > 0) {
              const { data } = result.data
              data.map((pkgPlan) => {
                const convertPkgPlan = {
                  value: pkgPlan.value,
                  label: pkgPlan.label
                }
                this.planList.push(convertPkgPlan)
              })
            } else {
              this.planList = []
            }
          } else {
            this.planList = []
          }
          this.planLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.planLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getTravelAreas() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.productTravelAreasGet
      if (apiURI) {
        try {
          this.areaLoading = true
          const expand = {
            product: this.interCommDiscFactorProduct
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            if (result.data.totalElements > 0) {
              const { data } = result.data
              data.map((travelArea) => {
                const convertTravelArea = {
                  value: travelArea.value,
                  label: travelArea.label
                }
                this.areaList.push(convertTravelArea)
              })
            } else {
              this.areaList = []
            }
          } else {
            this.areaList = []
          }
          this.areaLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.areaLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newInterCommDiscRate) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.menu.update
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.interCommDiscRateForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            const commitData = {
              interCommDiscFactTab: 1,
              displayFactReviewTab: true,
              displayRateTab: false
            }
            this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU, commitData)
            this.$router.push({ name: 'interCommDiscFactorReview', params: { product: this.interCommDiscFactorProduct, effectiveDate: this.interCommDiscFactorEffDate } })
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doCreate() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.interCommDiscRateCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.interCommDiscRateForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)

            // Stay on page
            this.newInterCommDiscRate = false
            const commitData = {
              interCommDiscFactTab: 1,
              displayFactReviewTab: true,
              displayRateTab: false
            }
            this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU, commitData)
            this.$router.push({ name: 'interCommDiscFactorReview', params: { product: this.interCommDiscFactorProduct, effectiveDate: this.interCommDiscFactorEffDate } })
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    fact1to3Search(fact) {
      if (fact === null) {
        return null
      } else {
        var found = this.factor1to3List.find(function (element) {
          return element.value === fact
        })
        if (found) {
          return found.label
        } else {
          return null
        }
      }
    },
    fact4to6Search(fact) {
      if (fact === null) {
        return null
      } else {
        var found = this.factor4to6List.find(function (element) {
          return element.value === fact
        })
        if (found) {
          return found.label
        } else {
          return null
        }
      }
    },
    factor1to3ValueListSearch(fact) {
      if (fact === null) {
        return null
      } else {
        if (fact === 'BCLS') {
          return this.busClsList
        } else if (fact === 'SCHM') {
          return this.schemeList
        } else if (fact === 'PLAN') {
          return this.planList
        } else if (fact === 'GEOG') {
          return this.areaList
        } else {
          return null
        }
      }
    },
    doEffDate() {
      // Format Effective Date
      if (this.effDate && this.effTime && this.effTime.length === 5) {
        const hr = this.effTime.substring(0, 2)
        const min = this.effTime.substring(3, 5)
        this.effDate = toDate(this.effDate)
        this.effDate.setHours(hr)
        this.effDate.setMinutes(min)
        this.interCommDiscRateForm.effDate = this.effDate
      }
    },
    doEndDate() {
      // Format Expiry Date
      if (this.endDate && this.endTime && this.endTime.length === 5) {
        const hr = this.endTime.substring(0, 2)
        const min = this.endTime.substring(3, 5)
        this.endDate = toDate(this.endDate)
        this.endDate.setHours(hr)
        this.endDate.setMinutes(min)
        this.interCommDiscRateForm.endDate = this.endDate
      } else {
        this.interCommDiscRateForm.endDate = undefined
      }
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    }
  },
  created() {
    if (this.rateId === 'New') {
      this.newInterCommDiscRate = true
      this.interCommDiscRateForm.inter = this.inter
      this.interCommDiscRateForm.product = this.interCommDiscFactorProduct
      this.effTime = '00:00'
      this.endTime = '00:00'
    } else {
      this.interCommDiscRateForm.inter = this.inter
      this.interCommDiscRateForm.product = this.interCommDiscFactorProduct
      if (this.rateId) {
        this.interCommDiscRateForm.effDate = this.rateId.effDate
        this.interCommDiscRateForm.fact1 = this.rateId.fact1
        this.interCommDiscRateForm.fact2 = this.rateId.fact2
        this.interCommDiscRateForm.fact3 = this.rateId.fact3
        this.interCommDiscRateForm.fact4 = this.rateId.fact4
        this.interCommDiscRateForm.fact5 = this.rateId.fact5
        this.interCommDiscRateForm.fact6 = this.rateId.fact6
      }
    }
    this.doInit()
  },
  props: {
    inter: {
      type: String,
      default: ''
    },
    product: {
      type: String,
      default: ''
    },
    rateId: {
      type: [Object, String],
      default: () => { }
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
